import request from "../request";

export default {
  // 列表
  lists(data) {
    return request.get("/block/lists", data);
  },
  
  // 列表
  getData(data) {
    return request.get("/block/getData", data);
  },
  
  //添加
  add(data) {
    return request.post("/block/add", data);
  },

  // 编辑
  edit(data) {
    return request.post("/block/edit", data);
  },

  // 删除
  delete(data) {
    return request.post("/block/delete", data);
  },
  
  // 删除
  bind(data) {
    return request.post("/block/bind", data);
  },

};
